import { css } from 'styled-components';

/** Column width rules for the 4-column documents table (header/body stay aligned). */
export const historicalDocumentsTableColumnStyles = css`
    th:nth-child(1),
    td:nth-child(1) {
        min-width: 10rem;
        max-width: 12rem;
    }

    th:nth-child(2),
    td:nth-child(2) {
        min-width: 7rem;
        max-width: 11rem;
    }

    th:nth-child(3),
    td:nth-child(3) {
        min-width: 7rem;
        max-width: 11rem;
    }

    th:nth-child(4),
    td:nth-child(4) {
        min-width: 5rem;
        max-width: 7rem;
        white-space: nowrap;
    }
`;
